
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class IssuedReminderModel extends Model<IssuedReminderModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'documentNo', type: 'string', languageString: 'issuedReminder.property.documentNo' },
		{ name: 'reminderLevel', type: 'number', languageString: 'issuedReminder.property.reminderLevel' },
		{ name: 'dueDate', type: 'Date', languageString: 'issuedReminder.property.dueDate' }
	];
	[key: string]: any;
	
	public documentNo: string;
	public reminderLevel: number;
	public dueDate?: Date;
    
	constructor(){
		super();
		this.documentNo = '';
		this.reminderLevel = 0;
		this.dueDate = undefined;
		
	}
	getProperties(){
		return IssuedReminderModel.classProperties;
	}
}

